// @flow

import { useLocation } from 'react-router-dom';

import { View } from 'reshaped';

import {
  selectCartTotal,
  selectUnusedDiscounts,
  selectDiscounts,
} from '@gandi/cart';

import { useAppSelector } from 'src/hooks/useAppSelector';

import DiscountRow from './DiscountRow';

export function DiscountRows(): React.MixedElement | null {
  const location = useLocation();
  const overviewPage = location.pathname.includes('overview');
  const total = useAppSelector(selectCartTotal);
  const allDiscounts = useAppSelector(selectDiscounts);
  const unusedDiscounts = useAppSelector(selectUnusedDiscounts);

  if (!overviewPage) return null;

  const unusedIds = unusedDiscounts.map(d => d.id);
  const unusedDiscountsData = allDiscounts.filter(d =>
    unusedIds.includes(d.id),
  );

  return (
    <View direction="column" gap={2}>
      {(total.discounts || []).map((discount, idx) => (
        <DiscountRow key={discount.code || idx} discount={discount} />
      ))}
      {unusedDiscountsData.map(unusedDiscount => (
        <DiscountRow key={unusedDiscount.id} discount={unusedDiscount} />
      ))}
    </View>
  );
}
